/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1434
 */

module.exports = function (e, t) {
  return function (n) {
    return e(t(n))
  }
}
